import { render, staticRenderFns } from "./FaceDiscLab.vue?vue&type=template&id=6002b2c5&scoped=true"
import script from "./FaceDiscLab.vue?vue&type=script&lang=js"
export * from "./FaceDiscLab.vue?vue&type=script&lang=js"
import style0 from "./FaceDiscLab.vue?vue&type=style&index=0&id=6002b2c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6002b2c5",
  null
  
)

export default component.exports